import React from 'react'
import { mergeStyleSets, Dropdown, ResponsiveMode, DropdownMenuItemType, useTheme } from '@fluentui/react'
import { monthDaysPositions, weekdays } from '../../../../../shared/services/scheduler'
import { capitalizeString } from 'shared/utils/utils';

const classNames = mergeStyleSets({
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '8px',
    },
    frequencyContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    frequencyInput: {
        flex: 'auto',
    },
    scheduleContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    }
})

const weekdaysPositionOptions = monthDaysPositions
    .weekdays
    .map(p => ({ key: `weekday_${p}`, value: p, text: capitalizeString(p), group: 'weekday' }));


const daysPositionOptions = monthDaysPositions
    .days
    .map(p => ({ key: `day_${p}`, value: p, text: `${capitalizeString(p)} of the month`, group: 'day' }));

const MounthdaySelector = ({ value, onChange }) => {

    const theme = useTheme()

    return (
        <div className={classNames.container}>
            <div className={classNames.scheduleContainer}>
                <Dropdown
                    selectedKey={`${value.type}_${value.position}`}
                    onChange={(_, option) => onChange({ ...value, type: option.group, position: option.value })}
                    responsiveMode={ResponsiveMode.large}
                    dropdownWidth='auto'
                    options={
                        [
                            { key: 'weekdays_header', text: 'Weekday', itemType: DropdownMenuItemType.Header },
                            ...weekdaysPositionOptions,
                            { key: 'divider', text: '-', itemType: DropdownMenuItemType.Divider },
                            { key: 'days_header', text: 'Day', itemType: DropdownMenuItemType.Header },
                            ...daysPositionOptions,
                        ]
                    }
                    theme={theme}
                />
                <Dropdown
                    disabled={value.type !== 'weekday'}
                    selectedKey={value.weekday}
                    onChange={(_, option) => onChange({ ...value, weekday: option.key })}
                    responsiveMode={ResponsiveMode.large}
                    options={weekdays.map(w => ({ key: w, text: w }))}
                    theme={theme}
                />
            </div>
        </div>
    )
}

export default MounthdaySelector